// Website content — used EXACTLY as provided. Do not paraphrase or edit copy.

export const NAV = {
  links: [
    { label: 'Founders', target: 'founders' },
    { label: 'Podcast', target: 'podcast' },
    { label: 'Join Us', target: 'enter' },
  ],
};

export const SOCIALS = {
  instagram: 'https://www.instagram.com/unscene.cult/',
  linkedin: 'https://www.linkedin.com/in/the-unscene-cult-6a9668440/',
  youtube: 'https://www.youtube.com/@TheUnsceneCult',
  substack: 'https://substack.com/@theunscenecult',
};

export const HERO = {
  title: 'THE RIGHT PEOPLE CHANGE EVERYTHING.',
  lines: [
    "The filmmaker you haven't met.",
    "The writer you haven't worked with.",
    'The musician who gets your idea.',
    'The person who turns your project into something bigger.',
    'UnScene Cult exists to bring them together.',
  ],
  formHeading: 'ENTER THE UNSCENE',
  fields: {
    name: { label: 'NAME', placeholder: 'Your name' },
    artForm: {
      label: 'ART FORM',
      options: ['Filmmaking', 'Photography', 'Writing', 'Music', 'Design', 'Other'],
    },
    email: { label: 'EMAIL ADDRESS', placeholder: 'Your email' },
    contact: { label: 'CONTACT NUMBER', placeholder: 'Your number' },
    work: { label: 'WORK LINKS', placeholder: 'Portfolio / Instagram / Website / LinkedIn' },
  },
};

export const SECOND_SCROLL = {
  emphasis: 'For artists who believe in being an artist.',
  body: 'The Unscene Cult is a global creative home for artists, makers and people who believe better things happen together.',
};

export const BELIEF = {
  overline: 'THE BELIEF',
  title: 'FROM VENDORS TO PARTNERS.',
  image: 'https://images.unsplash.com/photo-1772745681873-059634c8a98b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  paragraphs: [
    "We don't believe artists should spend their careers chasing invoices being a freelancer while someone else builds the world around their ideas.",
    'We believe creative people can build together, own together and grow together.',
  ],
  closing: "This isn't networking. It's world-building.",
};

export const MARQUEE_WORDS = ['Community', 'Collaboration', 'Opportunity', 'Ownership', 'Global', 'Culture'];

export const FOUNDERS = {
  overline: 'THE FOUNDERS',
  title: "WE COULDN'T FIND THIS PLACE. SO WE ARE BUILDING IT.",
  people: [
    {
      name: 'TANAYA',
      role: 'THE MAKER',
      titles: 'Filmmaker. VFX Artist. Creative Director.',
      bio: 'From animation to filmmaking to production, Tanaya brings ideas to life — and brings people together to make them happen.',
      image: '/assets/tanaya.webp',
      instagram: 'https://www.instagram.com/tanayadeepali/',
    },
    {
      name: 'DEEYA',
      role: 'THE EYES',
      titles: 'Cinematographer. Photographer. Storyteller.',
      bio: 'She finds stories in frames, people in places and beauty in the details others miss.',
      image: '/assets/deeya.webp',
      instagram: 'https://www.instagram.com/deeyasumeet/',
    },
    {
      name: 'SHOUMIK',
      role: 'THE QUESTION',
      titles: 'Writer. Brand Strategist. Idea Paglu.',
      bio: "He asks the unnecessary questions, follows strange ideas and connects dots that probably shouldn't connect.",
      image: '/assets/shoumik.webp',
      instagram: 'https://www.instagram.com/shoumikrahate/',
    },
  ],
};

export const PODCAST = {
  overline: 'THE UNSCENE PODCAST',
  title: 'THE CONVERSATIONS WE WISH WE HAD EARLIER.',
  name: 'THE UNSCENE PODCAST',
  image: '/assets/podcast.webp',
  lines: [
    'Art. Business. And the messy space in between.',
    'Conversations with artists, creators and people shaping the creative world.',
    'Two girls. Brutally honest questions.',
    'No gatekeeping. No polished answers. Just honest conversations.',
  ],
  cta: 'LISTEN TO THE PODCAST',
  link: 'https://www.youtube.com/@TheUnsceneCult',
};

export const SUBSTACK = {
  overline: 'SUBSTACK',
  title: 'THE UNSCENE SUBSTACK',
  cta: 'READ ON SUBSTACK',
  link: 'https://substack.com/@theunscenecult',
};

export const FINAL_CTA = {
  emphasis: 'For artists who believe in being an artist.',
  lines: [
    'Your next collaborator is out here. Your next idea is out there.',
    'Maybe it\u2019s time we found each other.',
  ],
  cta: 'JOIN THE UNSCENE CULT',
};

export const FOOTER_WORDS = ['Community', 'Collaboration', 'Opportunity', 'Ownership', 'Global', 'Culture'];

export const HERO_IMAGES = [
  'https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  'https://images.unsplash.com/photo-1761322572550-967ea8c0bfd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  'https://images.unsplash.com/photo-1549761505-a31eb21119d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  'https://images.unsplash.com/photo-1519772068161-ffd92063c4d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  'https://images.unsplash.com/photo-1765029582782-8b53b4ae41bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  'https://images.unsplash.com/photo-1602405385186-440222576763?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== 'undefined' && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
